const SeatsMapper = fn => ({
  order: -Infinity,
  run($$) {
    $$.seatsData.seats = $$.seatsData.seats.map(seat => fn(seat));
  },
});

window.SectionSeatsMapper = SeatsMapper;

export default SeatsMapper;
